/**
* DevExpress HTML/JS Reporting (viewer\binding\jsReportParametersPanel.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { JSReportViewerBase } from './jsReportViewerBase';
export class JSReportParametersPanel extends JSReportViewerBase {
    SerializeParametersState() {
        const parametersModelState = this.GetParametersModel()?.serializeParameters();
        return JSON.stringify(parametersModelState);
    }
}
